import React, { useContext, useEffect, useState } from 'react'
import Header from '../Header'
import Footer from '../Footer'
import "./walkInDescription.css"
import Descrpition from './Descrpition'
import SimilarWalkins from './SimilarWalkins'
import { FunctionContext } from '../../context/FunctionProvider'
function WalkInDescription() {
      const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
      const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 435);
       const {walkinlist} = useContext(FunctionContext);
      useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth <= 768);
     
        };
    
        window.addEventListener('resize', handleResize);
        
        // Cleanup listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
      }, []);
    return (
        <>
        <Header flag={isMobile}  mobileflag={isSmallMobile}></Header>
        <div className='w-div'>
{walkinlist &&<Descrpition walkinlist={walkinlist}></Descrpition>}
{!isMobile && <SimilarWalkins Similar_walkins={walkinlist?.data} ></SimilarWalkins>}
        </div>
        <Footer></Footer>
        </>
    )
}

export default WalkInDescription
